import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SafeResourceUrl } from '@angular/platform-browser';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'molla-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss']
})
export class PdfViewerComponent implements OnInit {
  pdfSrc: SafeResourceUrl | null = null;
  loading = true;
  errorMessage = '';
  zoomLevel: number = 1;
  pdfBlob: Blob | null = null;
  fileName: string = 'documento.pdf';

  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService
  ) {}

  ngOnInit(): void {
    // Nuova route stabile: /view-pdf/:codTipo/:codWeb
    const codTipo = this.route.snapshot.paramMap.get('codTipo')!;
    const codWeb  = this.route.snapshot.paramMap.get('codWeb')!;

    if (codTipo && codWeb) {
      this.loadPdfByWeb(codTipo, codWeb);
    } else {
      // Fallback retrocompatibile: vecchia route /view-pdf/:id
      const id = +this.route.snapshot.paramMap.get('id')!;
      if (id) {
        this.loadPdf(id);
      } else {
        this.errorMessage = 'Parametri non validi';
        this.loading = false;
      }
    }
  }

  // ── Nuovo metodo: carica tramite codice web (URL stabile per QR) ──────────
  async loadPdfByWeb(codTipo: string, codWeb: string) {
    const file = await this.apiService.GetFileByWeb(codTipo, codWeb);
    this.handleFileResponse(file);
  }

  // ── Metodo esistente: carica tramite ID fisico (retrocompatibilità) ───────
  async loadPdf(id: number) {
    const file = await this.apiService.GetFile(id);
    this.handleFileResponse(file);
  }

  // ── Helper condiviso ──────────────────────────────────────────────────────
  private handleFileResponse(file: { name: string; base64: string } | null) {
    if (file) {
      this.pdfBlob = new Blob(
        [Uint8Array.from(atob(file.base64), c => c.charCodeAt(0))],
        { type: 'application/pdf' }
      );
      this.pdfSrc   = URL.createObjectURL(this.pdfBlob);
      this.fileName = file.name;
    } else {
      this.errorMessage = 'Errore nel caricamento del PDF';
    }
    this.loading = false;
  }

  downloadPdf() {
    if (!this.pdfBlob) return;
    const url = URL.createObjectURL(this.pdfBlob);
    const a   = document.createElement('a');
    a.href     = url;
    a.download = this.fileName;
    a.click();
    URL.revokeObjectURL(url);
  }

  zoomIn()  { this.zoomLevel += 0.1; }
  zoomOut() { if (this.zoomLevel > 0.2) this.zoomLevel -= 0.1; }
}